export function getTelegramWebApp() {
    return window.Telegram?.WebApp ?? null;
}
export function getTelegramInitData() {
    const tg = getTelegramWebApp();
    return tg?.initData ?? '';
}
